import { useAtomValue } from 'jotai';

import { useAuth } from '@/hooks/useAuth';

import { getHighestUserRole } from '@/utils/user';

import Constants from '@/constants';

import { userInAISearchPOCAtom } from '@/atoms/ai-search-poc';
import { isUserSmartSearchEnabled } from '@/routes/Settings/SmartSearch/smartSearchUser';

/**
 * Whether Smart Search is active for the current user.
 * LD (`userInAISearchPOCAtom`) must be on. Then:
 * - Admin/Stakeholder: always on (no Settings toggle)
 * - Everyone else: XP `user.permissions.smartSearch` (runtime capability)
 */
export const useSmartSearchEnabled = (): boolean => {
  const ldEnabled = useAtomValue(userInAISearchPOCAtom);
  const { data: auth } = useAuth();

  if (!ldEnabled) {
    return false;
  }

  const highestUserRole = getHighestUserRole(auth?.roles ?? {});
  const isAlwaysEnabledRole =
    highestUserRole === Constants.USER_ROLE_NAMES.ADMIN ||
    highestUserRole === Constants.USER_ROLE_NAMES.STAKEHOLDER;

  return isAlwaysEnabledRole || isUserSmartSearchEnabled(auth);
};
